export default __webpack_public_path__ + "static/media/pointer-new.75107451.svg";